import { forwardRef, useState } from "react"
import { SearchIcon, XIcon } from "lucide-react"

import { Button } from "@f2e/ui/components/base"
import { InputPlus } from "@f2e/ui/components/base-plus"
import { cn } from "@f2e/ui/lib/utils"

export interface SearchInputProps {
  className?: string
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, placeholder, value, onChange }, ref) => {
    const [inputValue, setInputValue] = useState(value ?? "")

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value)
      onChange?.(event.target.value)
    }

    const handleClear = () => {
      setInputValue("")
      onChange?.("")
    }

    return (
      <div className={cn("relative w-full max-w-sm", className)}>
        <InputPlus
          ref={ref}
          className={"max-w-sm"}
          placeholder={placeholder}
          value={inputValue}
          startIcon={SearchIcon}
          onChange={handleChange}
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
          onClick={handleClear}
        >
          <XIcon className="h-4 w-4" />
          <span className="sr-only">Clear</span>
        </Button>
      </div>
    )
  }
)

export default SearchInput
